<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { VTabListSimple } from '@/modules/shared/components'
import { Tabs } from '../types'
const route = useRoute()
const router = useRouter()

const props = defineProps<{
  tabs: Tabs[]
}>()

const current_index = props.tabs.findIndex((tab) => tab.to.name === route.name)
const tab_names = props.tabs.map((tab) => tab.label)

const redirectPage = (index) => {
  const selected_tab = props.tabs[index]
  router.push(selected_tab.to)
}
</script>

<template>
  <VTabListSimple @update:current="redirectPage" :current="current_index" :tabs="tab_names" class="mb-6" size="base" />
</template>
